import { render, staticRenderFns } from "./BtnLocation.vue?vue&type=template&id=3ee8d2b2&"
import script from "./BtnLocation.vue?vue&type=script&lang=js&"
export * from "./BtnLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports